import { render, staticRenderFns } from "./AmchamdrOnline.vue?vue&type=template&id=6c0c2e90&scoped=true&"
import script from "./AmchamdrOnline.vue?vue&type=script&lang=js&"
export * from "./AmchamdrOnline.vue?vue&type=script&lang=js&"
import style0 from "./AmchamdrOnline.vue?vue&type=style&index=0&id=6c0c2e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c2e90",
  null
  
)

export default component.exports